import { Tab } from "@headlessui/react";
import clsx from "clsx";

import { ISummaryData } from "models/HaulPay";
import styles from "./style.module.scss";
import { CARRIER_FR_STATUS_LABELS } from "constants/base";

type StatusTabsProps = {
  tabsData: ISummaryData;
  summaryLabels?: { [key in string]: string };
};

export default function StatusTabs({
  tabsData,
  summaryLabels = CARRIER_FR_STATUS_LABELS
}: Readonly<StatusTabsProps>) {
  return (
    <Tab.List className={styles.tabList}>
      {Object.keys(summaryLabels).map((key) => {
        const label = summaryLabels[key];
        return tabsData[key] ? (
          <Tab
            key={key}
            className={({ selected }) =>
              clsx(
                styles.title,
                selected ? "text-primary border-b-2 border-primary" : "text-placeholder"
              )
            }>
            {({ selected }) => (
              <>
                <span className={selected ? "" : "text-text"}>{label} </span>
                <span>{tabsData[key]?.count ?? 0}</span>
              </>
            )}
          </Tab>
        ) : null;
      })}
    </Tab.List>
  );
}
